<template>
  <v-layout fill-height column class="page-solution-intro">
    <v-container flex-fill fluid>
      <div class="solution-intro-title">{{title}}</div>
      <div class="solution-intro-subtitle">{{smallTitle}}</div>
      <div class="solution-intro-desc" v-html="description"></div>
      <div class="solution-intro-content">
        <div class="dream-recording">
          <span class="tooltip">꿈내용 녹음하기</span>
          <v-btn icon :ripple="false"
                 class="btn-recording"
                 @click="sheetStatus"
          ><span></span></v-btn>
        </div>
      </div>
    </v-container>
    <FooterBtns :ok="'시작하기'" @submit="setMemberReply"/>
    <!-- <RecordingSheet :sheet="sheet" @sheetClose="sheetStatus" /> -->
    <RecordingSheet :sheet="sheet" :beForeVoiceNote="beForeVoiceNote" @sheetClose="sheetStatus" @recordingSave="recordingSave"/>
  </v-layout>
</template>
<script>
import RecordingSheet from "@/components/layout/bottomSheet/RecordingSheet"
import FooterBtns from "@/components/btns/FooterBtns"
import store from '../../store'
import utils from '../../utils/utils.js'

export default {
  props:["title","smallTitle","description","current","total","unitUseNo","unitDtlUseNo","unitDtlPageSeq","cmpltYn","freeYn"],
  data: ()=> ({
    sheet: false,
    voiceNote: '',
    beForeVoiceNote:0,
    replyObjArr:[],
    userReplyNo:[0],
    userReply:[],
    enableList:[],
    cmplt:false
  }),
  components:{
    RecordingSheet,
    FooterBtns,
  },
  computed: {
  },
  mounted () {
  },
  created () {
    this.getUnitDetailUse()
  },
  methods:{
    async getUnitDetailUse () {

      // 무료 여부
      this.free = this.freeYn
      // 완료 여부
      this.cmplt = this.cmpltYn
      // this.cmplt = true
      //console.log('this.free : ', this.free)
      //console.log('this.cmplt : ', this.cmplt)
      //console.log('this.regDt : ', this.regDt)

      // this.beForePhotoNo.splice(0, this.beForePhotoNo.length)

      await store.dispatch('getUnitDetailUse', this.$_payload('so',
          [{'unitUseNo': this.unitUseNo},
            {'unitDtlUseNo':this.unitDtlUseNo[0]},
            {'unitDtlPageSeq':this.unitDtlPageSeq[0]},
            {'freeYn':this.free}, {'regDt':this.regDt},
            {'feedbackUserKey': this.$route.query.feedbackUserKey}
          ]))
          .then(res => {
          if (res.success) {

            // 질문 리스트
            res.data.unitDtlQuesList.forEach((quesEl,i) => {

              // // 질문 셋팅
              // // this.ques[i] = quesEl.ques
              // this.ques.push(quesEl.ques)
              // // console.log("this.ques : ",this.ques)

              // 답변 셋팅
              quesEl.unitDtlReplyList.forEach((replyEl) => {
                // 렌더링 때문에 답변따로 먼저 저장 후 객체도 저장
                if(replyEl.reply == "녹음"){
                  // this.replyArr.push(replyEl.reply)
                  this.replyObjArr.push(replyEl)
                }
              });

              // 유저 답변 셋팅
              // console.log('memberUnitDtlReplyList : ', quesEl.memberUnitDtlReplyList)
              quesEl.memberUnitDtlReplyList.forEach((userReplyEl,j) => {
                this.userReplyNo[i+j] = userReplyEl.memberUnitDtlReplyUseNo

                if(userReplyEl.reply == '녹음'){
                  if(userReplyEl.score != null && userReplyEl.score > 0 ){
                    this.voiceNote = userReplyEl.score
                    this.beForeVoiceNote = userReplyEl.score
                  }
                }

              });

            });

          } else {
              console.log(res.msg)
              // this.answer = [];
          }
          })
          .catch(error => {
              console.error(error)
              // this.answer = [];
          })
          .finally(() => {})
    },
    async setMemberReply () {

      if(!this.cmplt){ // 완료상태가 아닐때만 저장
        // 유저 답변 셋팅

        // 녹음 답변
        var inputVoiceNote = 0
        if(this.voiceNote != ''){
          inputVoiceNote = this.voiceNote

          this.enableList.push(this.voiceNote)
        }

        console.log("voiceNote : ", this.voiceNote)
        console.log("inputVoiceNote : ", inputVoiceNote)
        this.userReply[0] = {
                              unitId: this.replyObjArr[0].unitId,
                              sltUnitMappingUseNo: this.replyObjArr[0].sltUnitMappingUseNo,
                              memberUnitDtlReplyUseNo: this.userReplyNo[0],
                              // unitUseNo: this.replyObjArr[0].unitUseNo,
                              unitNo: this.replyObjArr[0].unitNo,
                              // unitDtlUseNo: this.replyObjArr[0].unitDtlUseNo,
                              unitDtlNo: this.replyObjArr[0].unitDtlNo,
                              // unitDtlQuesUseNo: this.replyObjArr[0].unitDtlQuesUseNo,
                              unitDtlQuesNo: this.replyObjArr[0].unitDtlQuesNo,
                              // unitDtlReplyUseNo: this.replyObjArr[0].unitDtlReplyUseNo,
                              unitDtlReplyNo: this.replyObjArr[0].unitDtlReplyNo,
                              userKey: this.$store.state.auth.authUser.userKey,
                              reply: "녹음",
                              score: inputVoiceNote,
                              freeYn: this.free
                            }

        await store.dispatch('setMemberReply', this.$_payload('memberReplyList',this.userReply))
              .then(res => {
                if (res.success) {
                  if(this.enableList.length > 0){
                    utils.File.fileEnable(this.enableList
                      ).then(() => {
                        this.$emit('next')
                      })
                      .catch(async error => {
                        console.log(error)
                      })
                      .finally(() => {
                      })
                  } else{
                    setTimeout(() => this.$emit('next'), 500); // 저장한 이후
                  }
                } else {
                    console.log(res.msg)
                }
              })
              .finally(() => {
              })
      } else {
        this.$emit('next')
      }
    },
    sheetStatus(){
      if(!this.cmplt){
        this.sheet = !this.sheet;
      }
    },
    recordingSave(fileId, beforeFileId){

      if(fileId == 'error'){
        console.log('녹음파일 업로드 실패하였습니다.')
      } else{
          if(this.beForeVoiceNote > 0){
            this.voiceDelete(fileId)
          }else{
            this.voiceNote = fileId
            this.beForeVoiceNote = beforeFileId
            this.sheet = false
          }
      }
    },
    voiceDelete(newfileId){
      utils.File.fileDelete(this.voiceNote
        ).then(() => {

          this.voiceNote = newfileId
          this.beForeVoiceNote = newfileId
          this.sheet = false
        })
        .catch(async error => {
          console.log(error)
        })
        .finally(() => {
        })
    },
  }
}
</script>
